const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;
const FUNCHESTER_LOGO = `${API}/static/logo.jpg`;

// Permanent image URLs (bundled as static files, work on both preview and production)
const IMAGES = {
  heroBackground: `${API}/static/hero.jpg`,
  vaultBackground: `${API}/static/vault-bg.jpg`,
  watchLiveCard: `${API}/static/watch-live.jpg`,
  watchLivePlaceholder: `${API}/static/watch-live.jpg`,
  vaultCard: `${API}/static/vault-card.jpg`,
  championshipsCard: `${API}/static/championships.jpg`,
  supportUsCard: `${API}/static/support-us.jpg`,
  donateBackground: `${API}/static/donate-bg.jpg`,
  paypalIcon: `${API}/static/paypal.jpg`,
  venmoIcon: `${API}/static/venmo.jpg`,
  cashAppIcon: `${API}/static/cashapp.jpg`,
};

export { BACKEND_URL, API, FUNCHESTER_LOGO, IMAGES };
